/**
 * 인벤토리 품질점검·불확도 활용 가이드라인 (마크다운)
 * 인벤토리 상세 화면 가이드 버튼 모달에서 사용
 */
export const INVENTORY_QUALITY_UNCERTAINTY_GUIDE = `
> 이 가이드는 산정 후 점수(데이터 상태)와 오차 범위(결과 신뢰도)를 보고, 그대로 진행할지 또는 보완 후 다시 할지 판단하는 방법을 안내합니다.
- 품질점검(데이터 점검): 빠진 값, 이상한 값, 증빙 누락 등 무엇을 고칠지 알려줌
- 불확도(오차 범위): 결과가 얼마나 흔들릴 수 있는지(±%) 보여줌. 낮을수록 신뢰도 높음

#### 판단 기준
- 점수 70점 이상: 확인 후 진행 가능
- 점수 70점 미만: 자료 보완/재계산 후 재점검 권장
- 오차 범위 낮음(≈5% 미만): 진행 가능성이 높음
- 오차 범위 중간/높음(≈5% 이상): 원인 점검 후 필요 시 보완/재계산 권장
- 점수만 좋다고 끝내지 말고 점수+오차 범위를 둘 다 보고 완료하는 것이 안전합니다.

#### 추천 흐름
산정 완료 → 점수/문제목록 확인(필요 시 보완) → 오차 범위 확인(필요 시 보완) → 둘 다 수용 가능하면 점검 완료 진행

#### 자주 막히는 경우
“점검 완료” 후 다음 단계로 안 넘어가면 전체 산정이 완료 상태인지와 권한을 먼저 확인합니다.`;
